import { Route } from 'react-router-dom';

import { SettingsIntegrationsCardsMagentoCreateView } from './views/create';
import { SettingsIntegrationsCardsMagentoEditView } from './views/edit';
import { SettingsIntegrationsCardsMagentoTestView } from './views/test';

export const settingsIntegrationsCardsMagentoRoutes = (
  <Route path="magento-card">
    <Route
      path="edit/:id"
      element={<SettingsIntegrationsCardsMagentoEditView />}
    />
    <Route
      path="create"
      element={<SettingsIntegrationsCardsMagentoCreateView />}
    />
    <Route
      path="test/:id"
      element={<SettingsIntegrationsCardsMagentoTestView />}
    />
  </Route>
);
